import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { Tag } from "../../types/tag";
import useAxiosInstance from "../axiosConfig";
import { getTags } from "../endpoints/getEndPoints";

type TagsPage = {
  content: Tag[];
  number: number;
  last: boolean;
};

type UseInfiniteTagsArgs = {
  enabled?: boolean;
  search: string;
  pageSize?: number;
};

export const useInfiniteTags = ({
  enabled = true,
  search,
  pageSize = 20,
}: UseInfiniteTagsArgs) => {
  const axios = useAxiosInstance();

  const query = useInfiniteQuery({
    queryKey: ["infinite_tags", search.trim(), pageSize],
    initialPageParam: 0,
    enabled,
    queryFn: ({ pageParam }) =>
      getTags(axios, { page: pageParam as number, size: pageSize, search }),
    getNextPageParam: (lastPage: TagsPage) =>
      lastPage.last ? undefined : lastPage.number + 1,
  });

  const tags = useMemo(
    () => (query.data?.pages ?? []).flatMap((page: TagsPage) => page.content ?? []),
    [query.data]
  );

  return {
    ...query,
    tags,
  };
};
